import React from "react";
import { DesktopFrame, PhoneFrame, Chip } from "./frames";
import { ShieldCheck, Users, Building2, Flag, ScrollText, GitBranch } from "lucide-react";

const Side = () => (
  <div className="hidden w-40 shrink-0 flex-col bg-[#173A2C] p-4 text-white md:flex">
    <div className="font-serif text-base">Admin Console</div>
    <div className="mt-4 space-y-1 text-[11px]">
      {[[Users, "Candidate approvals", true], [Building2, "Employer approvals"], [Flag, "Feed & job moderation"], [GitBranch, "Stage management"], [ScrollText, "Audit log"]].map(([Icon, n, act], i) => (
        <div key={n} className={`flex items-center gap-2 rounded-sm px-2 py-1.5 ${act ? "bg-white/15" : "text-white/70"}`}><Icon className="h-3.5 w-3.5" />{n}</div>
      ))}
    </div>
  </div>
);

const Stat = ({ n, l, tone }) => (
  <div className="rounded-md border border-[#E8E4DB] bg-white p-3">
    <div className={`text-xl font-bold ${tone}`}>{n}</div>
    <div className="text-[10px] text-[#5C5855]">{l}</div>
  </div>
);

const QueueRow = ({ alias, sub, kind }) => (
  <tr className="border-b border-[#E8E4DB] text-[11px]">
    <td className="py-2 font-medium text-[#173A2C]">{alias}</td>
    <td className="py-2 text-[#5C5855]">{sub}</td>
    <td className="py-2">{kind === "rev" ? <Chip tone="amber">Pending revision</Chip> : <Chip tone="slate">New submission</Chip>}</td>
    <td className="py-2">
      <div className="flex gap-1">
        <button className="rounded-sm bg-[#2E6B4B] px-2 py-1 text-[9px] text-white">Approve</button>
        <button className="rounded-sm border border-[#8B3A3A] px-2 py-1 text-[9px] text-[#8B3A3A]">Request changes</button>
      </div>
    </td>
  </tr>
);

const Audit = () => (
  <div className="rounded-md border border-[#E8E4DB] bg-white p-3">
    <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C4A46B]">Audit log</div>
    <div className="mt-2 space-y-1.5 text-[10px] text-[#5C5855]">
      {["admin approved candidate HG-104 · 10:24", "employer ACME viewed HG-118 certificate · 10:19", "stage 'Visa' set on APP-3391 by admin · 09:58", "post #204 removed (report) by admin · 09:40"].map((l) => (
        <div key={l} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[#C4A46B]" />{l}</div>
      ))}
    </div>
  </div>
);

export const AdminDesktop = () => (
  <DesktopFrame testid="mock-admin-desktop" url="equiwelt.com/admin">
    <div className="flex h-full bg-[#FDFBF7]">
      <Side />
      <div className="flex-1 space-y-3 overflow-y-auto thin-scroll p-4">
        <div className="font-serif text-xl text-[#173A2C]">Candidate Approvals</div>
        <div className="grid grid-cols-4 gap-2">
          <Stat n="7" l="New submissions" tone="text-[#1F4A38]" />
          <Stat n="3" l="Pending revisions" tone="text-[#D28E3D]" />
          <Stat n="2" l="Employer requests" tone="text-[#1F4A38]" />
          <Stat n="5" l="Open reports" tone="text-[#8B3A3A]" />
        </div>
        <div className="rounded-md border border-[#E8E4DB] bg-white p-3">
          <table className="w-full text-left">
            <thead><tr className="border-b border-[#E8E4DB] text-[9px] uppercase tracking-wide text-[#5C5855]"><th className="py-1.5">Alias</th><th>Detail</th><th>Type</th><th>Action</th></tr></thead>
            <tbody>
              <QueueRow alias="HG-131" sub="New profile · 6 yrs exp" kind="new" />
              <QueueRow alias="HG-104" sub="Edited skills + new evidence" kind="rev" />
              <QueueRow alias="HG-127" sub="New profile · 2 yrs exp" kind="new" />
            </tbody>
          </table>
        </div>
        <Audit />
      </div>
    </div>
  </DesktopFrame>
);

export const AdminMobile = () => (
  <PhoneFrame testid="mock-admin-mobile">
    <div className="h-full overflow-y-auto thin-scroll bg-[#FDFBF7]">
      <div className="bg-[#173A2C] px-4 py-3 text-white"><div className="font-serif text-base">Admin</div><div className="text-[10px] text-white/70">Approvals & moderation</div></div>
      <div className="space-y-3 p-3">
        <div className="grid grid-cols-2 gap-2"><Stat n="7" l="New" tone="text-[#1F4A38]" /><Stat n="3" l="Revisions" tone="text-[#D28E3D]" /></div>
        <div className="rounded-md border border-[#E8E4DB] bg-white p-3 space-y-2">
          {[["HG-131", "New · 6 yrs"], ["HG-104", "Revision"]].map(([a, s]) => (
            <div key={a} className="flex items-center justify-between border-b border-[#E8E4DB] pb-2 last:border-0">
              <div><div className="text-[11px] font-semibold text-[#173A2C]">{a}</div><div className="text-[9px] text-[#5C5855]">{s}</div></div>
              <button className="rounded-sm bg-[#2E6B4B] px-2 py-1 text-[9px] text-white">Approve</button>
            </div>
          ))}
        </div>
        <Audit />
      </div>
    </div>
  </PhoneFrame>
);
